import PaymentList from '@/components/modules/payment/list';
import OrderDetail from '@/components/modules/invoice/details/index';
import Invoice from '@/components/modules/invoice/summary/index';
import ShowNote from '@/components/modules/payment/shownote';


const order = [
  {
    path: '/payments',
    name: 'PaymentList',
    component: PaymentList,
    meta: {
      title: 'Payment',
    },
  },
  {
    path: '/payments/orderdetail',
    name: 'OrderDetail',
    component: OrderDetail,
    meta: {
      title: 'OrderDetail',
    },
  },
  {
    path: '/payments/invoice',
    name: 'Invoice',
    component: Invoice,
    meta: {
      title: 'Invoice',
    },
  },
  {
    path: '/payments/shownote',
    name: 'ShowNote',
    component: ShowNote,
    meta: {
      title: 'ShowNote',
    },
  },
];

export default order;
